<template>
  <div class="misc-wrapper">
    <b-link class="brand-logo">
      <Logo />      
      <h2 class="brand-text text-primary ml-1">
        Salescore
      </h2>
    </b-link>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          No estás autorizado! 🔐
        </h2>
        <p class="mb-2">
         No tienes permiso para acceder a esta página.
        </p>
        <b-button
          variant="primary"
          class="mb-1 btn-sm-block"
          @click="redirectToDefault"
        >Regresar a Inicio</b-button>
        <b-img
          fluid
          :src="imgUrl"
          alt="Not authorized page"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import Logo from '@/modules/layouts/components/Logo.vue'
import store from '@/store/index'
import { login } from '@/modules/auth/mixins/login'

export default {
  mixins: [login],
  components: {
    Logo,
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/not-authorized.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/not-authorized-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
